export default "__VITE_ASSET__CeF5mLp3__"